import { render, staticRenderFns } from "./ShippingRequestComponent.vue?vue&type=template&id=b0770764&"
import script from "./ShippingRequestComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingRequestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports